import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "7-critical-factors-that-impact-foam-roof-replacement-cost-in-phoenix";
export const Route = createFileRoute("/7-critical-factors-that-impact-foam-roof-replacement-cost-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
